import React, { useMemo } from 'react';

import { IComponent } from '../../../typings/generic-component';
import { makeClassNames } from '../../../utils/styles';
import './competition-board-card-preview.scss';
import { ITeam, Winner } from '../../molecules/competition-board-card/competition-board-card';
import { getUrlStatic } from '../../../utils/placeholders-football';
import ImgPlaceholder from '../img-placeholder/img-placeholder';

const placeholder = `https://${getUrlStatic()}/images/skysport/configurations/placeholders/football/team-logo.png`;
export interface ICompetitionBoardCardPreview extends IComponent {
  onClick?: (e?: React.MouseEvent) => void;
  home?: ITeam;
  away?: ITeam;
  winner?: Winner;
}

const classNames = () =>
  makeClassNames({
    competitionBoardCardPreview: 'competition-board-card-preview',
    image: 'competition-board-card-preview__image',
    loserImage: 'competition-board-card-preview__image competition-board-card-preview__image--loser',
  });

const CompetitionBoardCardPreview: React.FC<ICompetitionBoardCardPreview> = ({ home, away, onClick, winner }) => {
  const cn = useMemo(() => classNames(), []);

  return (
    <div tabIndex={0} onClick={onClick} className={cn.competitionBoardCardPreview}>
      <div className={winner === 'away' ? cn.loserImage : cn.image}>
        <ImgPlaceholder title={home?.name || ''} src={home?.image || undefined} placeholder={placeholder} />
      </div>
      <div className={winner === 'home' ? cn.loserImage : cn.image}>
        <ImgPlaceholder title={away?.name || ''} src={away?.image || undefined} placeholder={placeholder} />
      </div>
    </div>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  CompetitionBoardCardPreview.propTypes = {};
}

export default CompetitionBoardCardPreview;
